<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('invoice.invoices')"
    >
      <ok-table
        ref="datatable"
        :config="config"
      >
        <template
          slot="bya3com-column"
          slot-scope="{props}"
        >
          <b-badge
            class="my-0"
            variant="warning"
          >
            {{ props.row.bya3com }}
          </b-badge>
        </template>
        <template
          slot="page-column"
          slot-scope="{props}"
        >
          <b-badge
            class="my-0"
            variant="primary"
          >
            {{ props.row.page }}
          </b-badge>
        </template>
        <template
          slot="package-column"
          slot-scope="{props}"
        >
          <b-badge
            class="my-0"
            variant="primary"
          >
            {{ getPackageName(props.row) }}
          </b-badge>
        </template>
        <template
          slot="package-price-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="success"
          >
            {{ getPackagePrice(props.row) }}
          </b-badge>

        </template>
        <template
          slot="paid-column"
          slot-scope="{props}"
        >
          <b-badge
            class="my-0"
            :variant="props.row.paid?'success':'danger'"
          >
            {{ $t('general.'+(props.row.paid?'yes':'no')) }}
          </b-badge>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import NotificationsApi from '@/api/notifications'
import InvoicesTableConfig from './config/invoices-table-config'

export default {
  components: {
    EmptyCard,
    OkTable,
    BBadge,
  },
  data() {
    return {
      config: InvoicesTableConfig,
    }
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    async markAsRead(props) {
      await this.$store.dispatch('auth/Mark_NOTIFICATION_READ', props.row.id)
      this.refreshTable()
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('webview.delete-template-message'), {
        preConfirm: () => NotificationsApi.delete(data.row.id)
          .then(response => {
            this.$notifySuccess('تمت عملية الحذف بنجاح')
            this.refreshTable()
            this.$store.commit('auth/SET_NOTIFICATIONS', response.notifications)
            this.$store.commit('auth/SET_NOTIFICATIONS_TOTAL', response.total)
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    getPackageName(row) {
      return row?.package?.name ?? 'غير محدد'
    },
    getPackagePrice(row) {
      return row?.package?.price ?? 'غير محدد'
    },
  },
}
</script>
